import React, { createContext, useContext } from 'react';
import { Cart } from '@shared/types/cart/Cart';

interface CartContextProps {
  cartDetails: Cart | null;
  setCartDetails: (cart: Cart | null) => void;
}

export const CartContext = createContext<CartContextProps | undefined>(undefined);

export const useCartContext = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCartContext must be used within a CartProvider');
  }
  return context;
};